/**
 * LISTENING TO IFRAME EVENTS
 * To listen to events sent from the iframe the object structure below
 * needs to be defined in the local Vue component's @type {data} object.
 * The list of expected @type {eventType}s as well as the structure of @type {event}
 * can be found at:
 * https://git.adriel.com/adriel/adriel-fe-react/-/blob/main/iframeMessage/types.ts
 *
 * @example
 * data: function () {
 *   return {
 *     ...
 *     iframeListeners: [
 *       {
 *         eventType: `SYNC_WORKSPACES`,
 *         listener: (event) => {},
 *       },
 *       {
 *         eventType: `USER_NAVIGATE`,
 *         listener: (event) => {},
 *       },
 *     ],
 *   }
 * })
 */
export default {
    data: () => ({
        iframeListeners_: [],
    }),
    computed: {
        _iframeListeners() {
            return this.iframeListeners_.map(({ eventType, listener }) => ({
                eventType,
                listener: (event) => {
                    if (event.data?.type !== eventType) {
                        return;
                    }
                    if (process.env.NODE_ENV === `development`) {
                        console.log(`vue - listener`, event.data);
                    }
                    listener(event.data);
                },
            }));
        },
    },
    beforeDestroy() {
        this.removeIframeListeners_(this._iframeListeners);
    },
    watch: {
        _iframeListeners: {
            immediate: true,
            handler(newIframeListeners, oldIframeListeners) {
                this.updateIframeListeners_(
                    newIframeListeners,
                    oldIframeListeners
                );
            },
        },
    },
    methods: {
        addIframeListeners_(iframeListeners) {
            iframeListeners?.forEach(({ listener }) =>
                window.addEventListener(`message`, listener)
            );
        },
        removeIframeListeners_(iframeListeners) {
            iframeListeners?.forEach(({ listener }) =>
                window.removeEventListener(`message`, listener)
            );
        },
        updateIframeListeners_(newIframeListeners, oldIframeListeners) {
            this.removeIframeListeners_(oldIframeListeners);
            this.addIframeListeners_(newIframeListeners);
        },
    },
};
